import {
  ADD_NEW_MERCHANT_GROUP,
  ADD_NEW_MERCHANT_GROUP_FAIL,
  ADD_NEW_MERCHANT_GROUP_SUCCESS,
  GET_MERCHANT_GROUP,
  GET_MERCHANT_GROUP_FAIL,
  GET_MERCHANT_GROUP_SUCCESS,
  CLEAR_MERCHANT_GROUP,
  UPLOAD_BASE64_FILE,
  UPLOAD_BASE64_FILE_FAIL,
  UPLOAD_BASE64_FILE_SUCCESS,
  GET_MERCHANT_GROUP_DETAIL,
  GET_MERCHANT_GROUP_DETAIL_FAIL,
  GET_MERCHANT_GROUP_DETAIL_SUCCESS,
  CLEAR_MERCHANT_GROUP_DETAIL,
  GET_MERCHANT_GROUP_COMMUNICATIONS,
  GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL,
  CLEAR_MERCHANT_GROUP_COMMUNICATIONS,
  MANAGE_MERCHANT_GROUP_COMMUNICATION,
  MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL,
  GET_MERCHANT_GROUP_CONTACTS,
  GET_MERCHANT_GROUP_CONTACTS_SUCCESS,
  GET_MERCHANT_GROUP_CONTACTS_FAIL,
  CLEAR_MERCHANT_GROUP_CONTACTS,
  MANAGE_MERCHANT_GROUP_CONTACT,
  MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS,
  MANAGE_MERCHANT_GROUP_CONTACT_FAIL,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL,
  GET_MERCHANT_GROUP_BANKING,
  GET_MERCHANT_GROUP_BANKING_SUCCESS,
  GET_MERCHANT_GROUP_BANKING_FAIL,
  CLEAR_MERCHANT_GROUP_BANKING,
  GET_MERCHANT_GROUP_BANKING_DETAIL,
  GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS,
  GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL,
  CLEAR_MERCHANT_GROUP_BANKING_DETAIL,
  ADD_NEW_MERCHANT_GROUP_BANKING,
  ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS,
  ADD_NEW_MERCHANT_GROUP_BANKING_FAIL,
  MANAGE_MERCHANT_GROUP_BANKING,
  MANAGE_MERCHANT_GROUP_BANKING_SUCCESS,
  MANAGE_MERCHANT_GROUP_BANKING_FAIL,
  TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT,
  TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_SUCCESS,
  TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_FAIL,
  CHECK_MERCHANT_GROUP_BANKING_STATUS,
  CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS,
  CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL,
  SET_CONTACT_CREATION_STATE,
  CLEAR_CONTACT_CREATION_STATE,
  DELETE_MERCHANT_GROUP,
  DELETE_MERCHANT_GROUP_SUCCESS,
  DELETE_MERCHANT_GROUP_FAIL,
  GET_MERCHANT_GROUP_ADMIN_USER,
  GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  GET_MERCHANT_GROUP_ADMIN_USER_FAIL,
  CLEAR_MERCHANT_GROUP_ADMIN_USER,
  CREATE_MERCHANT_GROUP_ADMIN_USER,
  CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL,
} from "./actionTypes"

export const getMerchantGroup = (options, history) => ({
  type: GET_MERCHANT_GROUP,
  payload: { options, history },
})

export const getMerchantGroupSuccess = merchantGroups => ({
  type: GET_MERCHANT_GROUP_SUCCESS,
  payload: merchantGroups,
})
export const getMerchantGroupFail = error => ({
  type: GET_MERCHANT_GROUP_FAIL,
  payload: error,
})

export const clearMerchantGroup = () => ({
  type: CLEAR_MERCHANT_GROUP,
})

// add new merchant group
export const addNewMerchantGroup = (data, options, history) => ({
  type: ADD_NEW_MERCHANT_GROUP,
  payload: { data, options, history },
})

export const addNewMerchantGroupSuccess = merchantGroup => ({
  type: ADD_NEW_MERCHANT_GROUP_SUCCESS,
  payload: merchantGroup,
})

export const addNewMerchantGroupFail = error => ({
  type: ADD_NEW_MERCHANT_GROUP_FAIL,
  payload: error,
})

// uploadBase64File
export const uploadBase64FileAction = payload => ({
  type: UPLOAD_BASE64_FILE,
  payload,
})

export const uploadBase64FileSuccess = file => ({
  type: UPLOAD_BASE64_FILE_SUCCESS,
  payload: file,
})

export const uploadBase64FileFail = error => ({
  type: UPLOAD_BASE64_FILE_FAIL,
  payload: error,
})

export const getMerchantGroupDetail = (options, history) => ({
  type: GET_MERCHANT_GROUP_DETAIL,
  payload: { options, history },
})

export const getMerchantGroupDetailSuccess = merchantGroups => ({
  type: GET_MERCHANT_GROUP_DETAIL_SUCCESS,
  payload: merchantGroups,
})
export const getMerchantGroupDetailFail = error => ({
  type: GET_MERCHANT_GROUP_DETAIL_FAIL,
  payload: error,
})

export const clearMerchantGroupDetail = () => ({
  type: CLEAR_MERCHANT_GROUP_DETAIL,
})

export const getMerchantGroupCommunications = (options, history) => ({
  type: GET_MERCHANT_GROUP_COMMUNICATIONS,
  payload: { options, history },
})

export const getMerchantGroupCommunicationsSuccess = communications => ({
  type: GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS,
  payload: communications,
})

export const getMerchantGroupCommunicationsFail = error => ({
  type: GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL,
  payload: error,
})

export const clearMerchantGroupCommunications = () => ({
  type: CLEAR_MERCHANT_GROUP_COMMUNICATIONS,
})

// Manage Merchant Group Communication
export const manageMerchantGroupCommunication = (data, options, history) => ({
  type: MANAGE_MERCHANT_GROUP_COMMUNICATION,
  payload: { data, options, history },
})

export const manageMerchantGroupCommunicationSuccess = communication => ({
  type: MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS,
  payload: communication,
})

export const manageMerchantGroupCommunicationFail = error => ({
  type: MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL,
  payload: error,
})


// Merchant Group Contacts
export const getMerchantGroupContacts = (options, history) => ({
  type: GET_MERCHANT_GROUP_CONTACTS,
  payload: { options, history },
})

export const getMerchantGroupContactsSuccess = contacts => ({
  type: GET_MERCHANT_GROUP_CONTACTS_SUCCESS,
  payload: contacts,
})

export const getMerchantGroupContactsFail = error => ({
  type: GET_MERCHANT_GROUP_CONTACTS_FAIL,
  payload: error,
})

export const clearMerchantGroupContacts = () => ({
  type: CLEAR_MERCHANT_GROUP_CONTACTS,
})

// Manage Merchant Group Contact
export const manageMerchantGroupContact = (data, options, history) => ({
  type: MANAGE_MERCHANT_GROUP_CONTACT,
  payload: { data, options, history },
})

export const manageMerchantGroupContactSuccess = contact => ({
  type: MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS,
  payload: contact,
})

export const manageMerchantGroupContactFail = error => ({
  type: MANAGE_MERCHANT_GROUP_CONTACT_FAIL,
  payload: error,
})

// Merchant Group Contact Communications
export const getMerchantGroupContactCommunications = (options, history) => ({
  type: GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
  payload: { options, history },
})

export const getMerchantGroupContactCommunicationsSuccess = communications => ({
  type: GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS,
  payload: communications,
})

export const getMerchantGroupContactCommunicationsFail = error => ({
  type: GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL,
  payload: error,
})

// Manage Merchant Group Contact Communication
export const manageMerchantGroupContactCommunication = (
  data,
  options,
  history
) => ({
  type: MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
  payload: { data, options, history },
})

export const manageMerchantGroupContactCommunicationSuccess =
  communication => ({
    type: MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS,
    payload: communication,
  })

export const manageMerchantGroupContactCommunicationFail = error => ({
  type: MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL,
  payload: error,
})

// Merchant Group Banking
export const getMerchantGroupBanking = (options, history) => ({
  type: GET_MERCHANT_GROUP_BANKING,
  payload: { options, history },
})

export const getMerchantGroupBankingSuccess = banking => ({
  type: GET_MERCHANT_GROUP_BANKING_SUCCESS,
  payload: banking,
})

export const getMerchantGroupBankingFail = error => ({
  type: GET_MERCHANT_GROUP_BANKING_FAIL,
  payload: error,
})

export const clearMerchantGroupBanking = () => ({
  type: CLEAR_MERCHANT_GROUP_BANKING,
})

// Manage Merchant Group Banking
export const manageMerchantGroupBanking = (data, options, history) => ({
  type: MANAGE_MERCHANT_GROUP_BANKING,
  payload: { data, options, history },
})

export const manageMerchantGroupBankingSuccess = banking => ({
  type: MANAGE_MERCHANT_GROUP_BANKING_SUCCESS,
  payload: banking,
})

export const manageMerchantGroupBankingFail = error => ({
  type: MANAGE_MERCHANT_GROUP_BANKING_FAIL,
  payload: error,
})

// Toggle Merchant Group Banking Default
export const toggleMerchantGroupBankingDefault = (data, options, history) => ({
  type: TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT,
  payload: { data, options, history },
})

export const toggleMerchantGroupBankingDefaultSuccess = banking => ({
  type: TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_SUCCESS,
  payload: banking,
})

export const toggleMerchantGroupBankingDefaultFail = error => ({
  type: TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_FAIL,
  payload: error,
})

// Merchant Group Banking Detail (List)
export const getMerchantGroupBankingDetail = (options, history) => ({
  type: GET_MERCHANT_GROUP_BANKING_DETAIL,
  payload: { options, history },
})

export const getMerchantGroupBankingDetailSuccess = bankingList => ({
  type: GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS,
  payload: bankingList,
})

export const getMerchantGroupBankingDetailFail = error => ({
  type: GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL,
  payload: error,
})

export const clearMerchantGroupBankingDetail = () => ({
  type: CLEAR_MERCHANT_GROUP_BANKING_DETAIL,
})

// Add New Merchant Group Banking
export const addNewMerchantGroupBanking = (data, options, history) => ({
  type: ADD_NEW_MERCHANT_GROUP_BANKING,
  payload: { data, options, history },
})

export const addNewMerchantGroupBankingSuccess = banking => ({
  type: ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS,
  payload: banking,
})

export const addNewMerchantGroupBankingFail = error => ({
  type: ADD_NEW_MERCHANT_GROUP_BANKING_FAIL,
  payload: error,
})

// Contact Creation Phase State Management
export const setMerchantGroupContactCreationState = state => ({
  type: SET_CONTACT_CREATION_STATE,
  payload: state,
})

export const clearMerchantGroupContactCreationState = () => ({
  type: CLEAR_CONTACT_CREATION_STATE,
})

// Delete Merchant Group
export const deleteMerchantGroup = (data, options, history) => ({
  type: DELETE_MERCHANT_GROUP,
  payload: { data, options, history },
})

export const deleteMerchantGroupSuccess = response => ({
  type: DELETE_MERCHANT_GROUP_SUCCESS,
  payload: response,
})

export const deleteMerchantGroupFail = error => ({
  type: DELETE_MERCHANT_GROUP_FAIL,
  payload: error,
})

// Merchant Group Admin User
export const getMerchantGroupAdminUser = (options, history) => ({
  type: GET_MERCHANT_GROUP_ADMIN_USER,
  payload: { options, history },
})

export const getMerchantGroupAdminUserSuccess = adminUser => ({
  type: GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  payload: adminUser,
})

export const getMerchantGroupAdminUserFail = error => ({
  type: GET_MERCHANT_GROUP_ADMIN_USER_FAIL,
  payload: error,
})

export const clearMerchantGroupAdminUser = () => ({
  type: CLEAR_MERCHANT_GROUP_ADMIN_USER,
})

// Create Merchant Group Admin User
export const createMerchantGroupAdminUser = (data, options, history) => ({
  type: CREATE_MERCHANT_GROUP_ADMIN_USER,
  payload: { data, options, history },
})

export const createMerchantGroupAdminUserSuccess = adminUser => ({
  type: CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  payload: adminUser,
})

export const createMerchantGroupAdminUserFail = error => ({
  type: CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL,
  payload: error,
})

// Check Merchant Group Banking Status
export const checkMerchantGroupBankingStatus = (destinationID) => ({
  type: CHECK_MERCHANT_GROUP_BANKING_STATUS,
  payload: { destinationID },
})

export const checkMerchantGroupBankingStatusSuccess = (destinationID, status) => ({
  type: CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS,
  payload: { destinationID, status },
})

export const checkMerchantGroupBankingStatusFail = error => ({
  type: CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL,
  payload: error,
})
